import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';
import SearchBox from 'app/components/commons/search/SearchBox';
import styles from './NestedDropdown.module.scss';

const NestedDropdown = props => {
  const [search, setSearch] = useState('');
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setOptions(props.options);
  }, [props.options]);

  const onSearchChange = e => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    setOptions(
      props.options.filter(option => option.text.toLowerCase().includes(search.toLowerCase()))
    );
  }, [search]); //eslint-disable-line

  return (
    <div className={styles.container}>
      <div className={styles.inputHeader}>{props.name}</div>
      <div className={styles.search}>
        <SearchBox
          value={search}
          size={'small'}
          onChange={onSearchChange}
          label={''}
          placeholder={''}
        />
      </div>

      {/* <Input
        required
        className={styles.input}
        icon='search'
        onChange={onSearchChange}
        value={search}
      /> */}
      <div className={styles.container}>
        <List className={styles.list}>
          {options.map(option => {
            return (
              <button
                className={styles.button}
                key={option.value}
                onClick={() => props.onOptionSelection(option, props.name)}
              >
                {option.text}
              </button>
            );
          })}
        </List>
      </div>
    </div>
  );
};

NestedDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.number
    })
  ),
  onOptionSelection: PropTypes.func
};

export default NestedDropdown;
